/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grassy_Brave_Yak_AgreeInputs */

const es_grassy_brave_yak_agree = /** @type {(inputs: Grassy_Brave_Yak_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña debe tener al menos 10 caracteres`)
};

const gl_grassy_brave_yak_agree = /** @type {(inputs: Grassy_Brave_Yak_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O contrasinal debe ter polo menos 10 caracteres.`)
};

const en_grassy_brave_yak_agree = /** @type {(inputs: Grassy_Brave_Yak_AgreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The password must be at least 10 characters long.`)
};

/**
* | output |
* | --- |
* | "The password must be at least 10 characters long." |
*
* @param {Grassy_Brave_Yak_AgreeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const grassy_brave_yak_agree = /** @type {((inputs?: Grassy_Brave_Yak_AgreeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grassy_Brave_Yak_AgreeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_grassy_brave_yak_agree(inputs)
	if (locale === "en") return en_grassy_brave_yak_agree(inputs)
	return es_grassy_brave_yak_agree(inputs)
});